module.exports = __webpack_public_path__ + "img/RadioGroup.dcd719af.svg";